export default __webpack_public_path__ + "static/media/logo.e19fed86.png";